// Hata sayfası metinlerinin yerleşik varsayılanları. Sitede gösterilen metinler Site Yönetimi → Genel sayfa metinleri →
// Hata sayfası'ndan (kök düzen LocaleProvider ile iletir); bu küçük küme hata sınırının (error.tsx, istemci bileşeni)
// bağlam yokken kullandığı yedektir ve site-content varsayılanlarının (GENERAL_DEFAULTS, EN_GENERAL) kaynağıdır.

export type ApiErrorTexts = { title: string; text: string; retry: string; home: string };

export const apiErrorTexts: Record<"tr" | "en", ApiErrorTexts> = {
  tr: {
    title: "Tur bilgileri şu anda alınamıyor",
    text: "Rezervasyon sistemine şu an ulaşamıyoruz. Bu, tur bulunmadığı anlamına gelmez. Birkaç dakika sonra yeniden deneyebilir veya bizi arayabilirsiniz.",
    retry: "Yeniden dene",
    home: "Ana sayfa",
  },
  en: {
    title: "Tour information is unavailable right now",
    text: "We can't reach our reservation system at the moment. This doesn't mean there are no tours. Please try again in a few minutes or give us a call.",
    retry: "Try again",
    home: "Home",
  },
};
